import styled from 'styled-components';

import Typography from '@common/components/Typography';
import { TitleButtonWrapper } from '@common/components/Accordion/Accordion.styled';

export const AccordionWrapper = styled.div`
  flex-shrink: 1;
  ${({ noBottomSpacing, theme }) =>
    noBottomSpacing &&
    theme.getFluidSpacing('margin-bottom', 'widthBased', 1, true)};
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'scale', 2)}

  ${TitleButtonWrapper} {
    ${({ theme }) => theme.getFluidSpacing('padding-top', 'equal', 7)};
  }
`;

export const SectionDescriptionTitle = styled(Typography).attrs({
  variant: 'paragraph1',
})`
  margin-bottom: 0;
  font-weight: 700;
  line-height: 2.4rem;
`;

export const SectionDescription = styled(Typography).attrs({
  variant: 'paragraph2',
})`
  white-space: pre-wrap;
`;

export const ProductDescription = styled(Typography).attrs({
  variant: 'paragraph1',
})`
  & p:first-child {
    margin-top: 0;
  }

  & p:last-child {
    margin-bottom: 0;
  }
`;
